import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import lat1 from "../../assets/homeAssets/lat1.jpg";
import lat2 from "../../assets/homeAssets/lat2.jpg";
import lat3 from "../../assets/homeAssets/lat3.jpg";
import lat4 from "../../assets/homeAssets/lat4.jpg";

// --- Styled Components ---

const Section = styled.section`
  padding: 4em 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
`;

const TitleWrapper = styled.div`
  position: relative;
  margin-bottom: 40px;
  width: 100%;
  max-width: 1200px;
  display: flex;
  align-items: flex-end;

  @media (max-width: 768px) {
    /* justify-content: center; */
  }
`;

const TheText = styled.span`
  font-family: "Brush Script MT", cursive;
  font-size: 6rem;
  color: #8e7479;
  position: absolute;
  left: 20px;
  bottom: 0px;
  z-index: 1;
  opacity: 0.6;

  @media (max-width: 768px) {
    font-size: 4rem;
    left: 10px;
  }

  @media (max-width: 500px) {
    font-size: 3rem;
    left: 5px;
  }
`;

const LatestText = styled.h2`
  font-family: "Lovelace", serif;
  font-style: italic;
  font-size: 8rem;
  font-weight: 700;
  color: #63564e;
  margin: 0;
  padding-left: 150px;
  letter-spacing: -2px;

  @media (max-width: 768px) {
    font-size: 5rem;
    padding-left: 100px;
  }

  @media (max-width: 500px) {
    font-size: 3.5rem;
    padding-left: 60px;
  }
`;

const GalleryGrid = styled(motion.div)`
  display: grid;
  gap: 20px;
  width: 100%;
  max-width: 1300px;
  justify-content: center;

  /* Desktop: 4 in a row */
  grid-template-columns: repeat(4, 1fr);

  /* Tablet: 2x2 */
  @media (max-width: 1000px) {
    grid-template-columns: repeat(2, 1fr);
    max-width: 700px;
  }

  /* Mobile: 1 per row */
  @media (max-width: 500px) {
    grid-template-columns: 1fr;
    max-width: 350px;
  }
`;

const Parallelogram = styled(motion.div)`
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: #2a2a2a;
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.12);
  border-radius: 25px;
  border: 5px solid #c7b4b4;
  width: 100%;

  /* Make all cards the same size */
  aspect-ratio: 3/4;
`;

const ImageContainer = styled(motion.div)`
  width: 100%;
  height: 100%;
  /* Counter-skew keeps the lash images perfectly straight */
  transform: scale(1.1);
  background-image: url(${(props) => props.img});
  background-size: cover;
  background-position: center;

  /* Adjust scale for different screen sizes */
  @media (max-width: 1000px) {
    transform: scale(1.05);
  }

  @media (max-width: 500px) {
    transform: scale(1);
  }
`;

// --- Animation Variants ---

const containerVariants = {
  visible: {
    transition: {
      staggerChildren: 0.15,
    },
  },
};

const itemVariants = {
  hidden: {
    opacity: 0,
    y: 60,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 1.2,
      ease: [0.16, 1, 0.3, 1],
    },
  },
};

// --- Component ---

const LashLatestWork = () => {
  const lashImages = [lat1, lat2, lat3, lat4];

  return (
    <Section>
      <TitleWrapper>
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 1 }}
        >
          <TheText>The</TheText>
          <LatestText>Latest</LatestText>
        </motion.div>
      </TitleWrapper>

      <GalleryGrid
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
      >
        {lashImages.map((src, index) => (
          <Parallelogram key={index} variants={itemVariants}>
            <ImageContainer
              img={src}
              whileHover={{ scale: 1.08 }}
              transition={{ duration: 0.6 }}
            />
          </Parallelogram>
        ))}
      </GalleryGrid>
    </Section>
  );
};

export default LashLatestWork;
